module.exports = __webpack_public_path__ + "img/bg41.d61a5ac6.png";